import { loadOrgRecords } from "../../api/connection";
import { createModel, Model } from "../../models/Model";
import { ModelRenderer } from "../ModelRenderer";
import { MREvents } from "../MREvents";
import { BaseMRService } from "./BaseMRService";

export class ModelDataService extends BaseMRService {
  public models = new Map<string, Model>(); // Replace 'any' with your model type
  public loaded = false;
  constructor(mr: ModelRenderer) {
    super(mr);
  }
  public async load(): Promise<void> {
    const models = await loadOrgRecords<Model>("models", createModel);
    models.forEach(model => {
      this.models.set(model._id, model);
    });
    console.log("Models loaded:", models);
    this.mr.emitEvent(MREvents.ModelsLoaded, models);
    this.loaded = true;
  }
  
  public async waitForLoad(): Promise<void> {
    if (this.loaded) {
      return;
    }
    return new Promise((resolve) => {
      const listener = () => {
        this.mr.removeListener(MREvents.ModelsLoaded, listener);
        resolve();
      };
      this.mr.onEvent(MREvents.ModelsLoaded, listener);
    });
  }

  public render(delta: number): void {
    // Render logic for model data if needed
  }

  public dispose(): void {
    // Cleanup logic if needed
  }
}